module.exports = __webpack_public_path__ + "img/IH.ed7def4a.png";